import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  initializeAuth,
  selectInitLoading,
  selectIsAuthenticated,
} from "../redux";

/**
 * AppInitializer - Handles app-wide initialization
 * - Restores auth session on app load
 * - Shows loading state while initializing
 */
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectInitLoading);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    // Generate/ensure guestId is saved by default
    import("../utils/tokenHelper").then(({ getGuestId }) => getGuestId());
    
    // Initialize auth state from storage
    dispatch(initializeAuth());
  }, [dispatch]);

  // Debug logging for auth state
  useEffect(() => {
    if (!isLoading) {
      console.log(
        "[Auth] Initialization complete. Authenticated:",
        isAuthenticated,
      );
    }
  }, [isLoading, isAuthenticated]);

  if (isLoading) {
    // You can replace this with a proper loading component/spinner
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  return children;
};

export default AppInitializer;
